import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import ChangePassword from "../pages/Dashboard/Profile/ChangePassword";
import ProfileEditPage from "../pages/Dashboard/Profile/ProfileEditPage";
import ProfileDetailPage from "../pages/Dashboard/Profile/ProfileDetailPage";
import InvestorUploadAvatar from "../pages/Dashboard/Investor/UploadAvatar";
import MentorUploadAvatar from "../pages/Dashboard/Mentor/UploadAvatar";

import ChangePasswordMentor from "../pages/Dashboard/Mentor/ChangePassword";
import MentorProfileEditPage from "../pages/Dashboard/Mentor/ProfileEditPage";
import MentorProfileDetailPage from "../pages/Dashboard/Mentor/ProfileDetailPage";

import InvestorProfileEditPage from "../pages/Dashboard/Investor/ProfileEditPage";
import InvestorProfileDetailPage from "../pages/Dashboard/Investor/ProfileDetailPage";

import useAuth from "../context/AuthContext";
import UploadAvatar from "../pages/Dashboard/Profile/UploadAvatar";

const ProfileNavigator = () => {
  const { path } = useRouteMatch();

  const {
    state: { user },
  } = useAuth();

  let RoleProfileEdit = null;
  let RoleProfileDetail = null;
  let RoleUploadProfile = null;

  if (user && user.role === "investor") {
    RoleProfileDetail = InvestorProfileDetailPage;
    RoleUploadProfile = InvestorUploadAvatar;
    RoleProfileEdit = InvestorProfileEditPage;
  } else if (user && user.role === "mentor") {
    RoleProfileDetail = MentorProfileDetailPage;
    RoleUploadProfile = MentorUploadAvatar;
    RoleProfileEdit = MentorProfileEditPage;
  } else {
    RoleProfileDetail = ProfileDetailPage;
    RoleUploadProfile = UploadAvatar;
    RoleProfileEdit = ProfileEditPage;
  }

  return (
    <Switch>
      <Route path={`${path}/edit-profile`} component={RoleProfileEdit} />
      <Route path={`${path}/change-password`} component={ChangePassword} />
      <Route path={`${path}/upload-picture`} component={RoleUploadProfile} />

      <Route path={path} component={RoleProfileDetail} />
    </Switch>
  );
};

export default ProfileNavigator;
